module.exports = __webpack_public_path__ + "static/img/5.213981d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/5.png
// module id = Nw3q
// module chunks = 0